/**
 * Team Chat feature gate (mirrors ops flag ENABLE_TEAM_CHAT for Vite: VITE_ENABLE_TEAM_CHAT).
 * - `VITE_ENABLE_TEAM_CHAT=false` → always off
 * - `VITE_ENABLE_TEAM_CHAT=true` → always on
 * - unset → on in development only (safe default for production bundles)
 */
export function isTeamChatEnabled(): boolean {
  const v = import.meta.env.VITE_ENABLE_TEAM_CHAT;
  if (v === 'false') return false;
  if (v === 'true') return true;
  return Boolean(import.meta.env.DEV);
}
